module.exports = __webpack_public_path__ + "img/21_72.614aac33.png";